import { render, staticRenderFns } from "./NotificationRecipientsListDialog.vue?vue&type=template&id=c6c5b522&scoped=true&lang=pug"
import script from "./NotificationRecipientsListDialog.vue?vue&type=script&lang=js"
export * from "./NotificationRecipientsListDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipientsListDialog.vue?vue&type=style&index=0&id=c6c5b522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5b522",
  null
  
)

export default component.exports